import { AdvisorRoutes } from "@common/constants";
import { FC } from "react";
import {
  HiOutlineHome,
  HiOutlineCog,
  HiOutlineGlobe,
  HiOutlineLogout,
} from "react-icons/hi";
import SidebarLink from "../Sidebar/SidebarLink";
import CasesTasksSidebarLink from "../AdvisorSidebar/CasesTasksSidebarLink";
import { useAtlasExperience, useLogout } from "@common/hooks";
import { FeatureFlags } from "@common/constants";
import { useFlags } from "launchdarkly-react-client-sdk";

interface MobileAdvisorLinksProps {
  onClick: () => void;
}
const MobileAdvisorLinks: FC<MobileAdvisorLinksProps> = ({ onClick }) => {
  const { setShowLogoutDialog } = useLogout();
  const { isAtlasExperienceEnabled } = useAtlasExperience();
  const flags = useFlags();
  return (
    <div className="grid gap-y-3">
      <span className="sidebar-section-text-expanded">Wealth Advisor</span>
      <SidebarLink
        href={AdvisorRoutes.Households}
        icon={<HiOutlineHome />}
        text="Households"
        onClickLink={onClick}
      />
      {flags[FeatureFlags.COMMAND_CENTER] &&
        flags[FeatureFlags.CASES_AND_TASKS] && (
          <CasesTasksSidebarLink onClickLink={onClick} />
        )}
      {isAtlasExperienceEnabled && (
        <SidebarLink
          href={AdvisorRoutes.Atlas}
          icon={<HiOutlineGlobe />}
          text="Atlas"
          onClickLink={onClick}
        />
      )}
      <SidebarLink
        href={AdvisorRoutes.Settings}
        icon={<HiOutlineCog />}
        text="Settings"
        onClickLink={onClick}
      />
      <SidebarLink
        text="Log Out"
        icon={<HiOutlineLogout />}
        href=""
        onClickLink={() => setShowLogoutDialog(true)}
      />
    </div>
  );
};

export default MobileAdvisorLinks;
